/*=========================================================================================
  File Name: module-invoicetrial-getters.js
  Description: InvoiceBotTrial Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBotTrials
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	getSizePdf(state) {
		return state.sizePdf;
	}
};
